const COOKIE_SIZE_NAME = 'sizes';
const SIZE_OPTION_NAME = 'opt_size';
const SIZE_PROPERTY_NAME = `pf_${SIZE_OPTION_NAME}`;

let showSizeModal = (savedSelectedSizes, data) => {
	// open modal
	// find the size values

	let sizeOptionArray = data.filter.options.filter(option => {
		return option.label == "Size" || option.filterType == SIZE_OPTION_NAME
	});
	let sizeOption = sizeOptionArray[0];
	let existingSizes = [];

	[savedSelectedSizes].forEach(selectedSize => {
		let isSelectedSize = sizeOption.values.filter(sizeOptionValue => selectedSize == sizeOptionValue.key);
		if (isSelectedSize.length) {
			if( /[a-zA-Z]/.test(selectedSize) ){
				if( selectedSize == 'XS' || selectedSize == 's' || selectedSize == 'M' || selectedSize == 'L' || selectedSize == 'XL' || selectedSize == 'XXL' || selectedSize == '3XL' || selectedSize == 'One Size' ) return;
				existingSizes.push(selectedSize);
			}
		}
	});

	if (existingSizes.length) {
		Cookies.set(COOKIE_SIZE_NAME, JSON.stringify(existingSizes[0]), { expires: 30, path: '/' });
	}

	// attach modal data and events
	let $sizeElement = $(".size_val");
	let $sizeOnePlusElement = $(".size_one_plus");
	let $sizeExistElement = $(".size-exist");
	let $sizeNotExistElement = $(".size-not-exist");
	let $okButtonElement = $(".str_ok_button a");
	let $openButtonElement = $(".js-open-modal");
	let $closeButtonElement = $(".js-modal-close");
	let $showAllButtonElement = $(".str_show_btn");
	let $forgetSizesButtonElement = $(".str_forgot_btn");
	let $modal = $("#popup.modal-box");

	if (existingSizes.length) {
		if (existingSizes.length == 1) {
			$sizeOnePlusElement.css('display', 'none');
		}
		$sizeElement.html(existingSizes.join(', '));
		$sizeExistElement.css('display', 'block');
		$sizeNotExistElement.css('display', 'none');
	} else {
		$sizeExistElement.css('display', 'none');
		$sizeNotExistElement.css('display', 'block');
	}

	// update button
	let searchParamsWithSizes = new URL(window.location).searchParams;
	searchParamsWithSizes.delete(SIZE_PROPERTY_NAME);

	if (existingSizes.length) {
		existingSizes.forEach(size => {
			searchParamsWithSizes.append(SIZE_PROPERTY_NAME, size);
		});

		$okButtonElement.attr('href', `${window.location.pathname}?${searchParamsWithSizes.toString()}`);
	} else if (!existingSizes.length && savedSelectedSizes.length) {
		// no items
	}

	if (existingSizes.length) {
		// attach events
		$showAllButtonElement.on('click', function (event) {
			event.preventDefault();
			$('body').removeClass("scrolllock");
			$closeButtonElement.trigger('click');
		});

		$forgetSizesButtonElement.on('click', function (event) {
			event.preventDefault();
			$('body').removeClass("scrolllock");
			Cookies.remove(COOKIE_SIZE_NAME);
			$closeButtonElement.trigger('click');
		});

		$closeButtonElement.on('click', function (event) {
			event.preventDefault();
			$('body').removeClass("scrolllock");
		});

		// open modal
		setTimeout(() => {
			$("html, body").animate({ scrollTop: 0 }, 0);
		}, 300);
		$('body').addClass("scrolllock");
		$openButtonElement.trigger('click');
		$modal.css('display', 'block');
		$(window).resize();
	}
}


let handleCollectionLoad = (data) => {
	//load more logic
	let loadMoreButton = document.querySelector('.boost-pfs-filter-load-more-button');
	if (loadMoreButton) {
		loadMoreButton.addEventListener('click', () => {
			// setFixedContent(true)
		});
	}

	let ingoreCollectionSelectedSizes = Cookies.get('IGNORE_COLLECTION_SELECTED_SIZES');
	if (ingoreCollectionSelectedSizes != '1') {
		//size logic
		const SIZE_PROPERTY_NAME = `pf_${SIZE_OPTION_NAME}`;
		let currentUrl = new URL(window.location);
		let currentSearchParams = currentUrl.searchParams;
		let currentSelectedSizes = currentSearchParams.getAll(SIZE_PROPERTY_NAME);

		let savedSelectedSizes = Cookies.get(COOKIE_SIZE_NAME);
		if (savedSelectedSizes && savedSelectedSizes != 'undefined') {
			savedSelectedSizes = JSON.parse(savedSelectedSizes);
			/**
			 * compare existing size selection
			 */
			if (JSON.stringify(currentSelectedSizes) !== JSON.stringify(savedSelectedSizes)) {
				// showSizeModal(savedSelectedSizes, data);
			}
		} else {
			Cookies.remove(COOKIE_SIZE_NAME);
		}
	}
}

let handleSizeChange = () => {
	const SIZE_PROPERTY_NAME = `pf_${SIZE_OPTION_NAME}`;
	let currentUrl = new URL(window.location);
	let currentSearchParams = currentUrl.searchParams;
	let currentSelectedSizes = currentSearchParams.getAll(SIZE_PROPERTY_NAME);

	if (currentSelectedSizes.length) {
			Cookies.set(COOKIE_SIZE_NAME, JSON.stringify(currentSelectedSizes[0]), { expires: 30, path: '/' });
	} else {
			Cookies.remove(COOKIE_SIZE_NAME);
	}
}

let handleChange = (data, eventType) => {

	let ingoreCollectionSelectedSizes = Cookies.get('IGNORE_COLLECTION_SELECTED_SIZES');
	if (ingoreCollectionSelectedSizes != '1') {
		if (data.event_type == "filter" && boostPFS.filter.clickedFilterOptionId == `pf_${SIZE_OPTION_NAME}`) {
			handleSizeChange();
		}
	}

		if (data.event_type == "init") {
			handleCollectionLoad(data);
		}

	if (data.event_type == "page") {
		// setFixedContent(false);
	}
}
